module.exports = __webpack_public_path__ + "img/fullstackProject.45933695.svg";